import React, { PureComponent } from 'react'
import { Paper, ListItem, Grid } from '@material-ui/core'

// utils
import { onChangeEditHOF } from '../../utils/common'
import { hasAccess, createGetUrl } from '../../utils/api'
// actions

// local components
import EditActionComponent from '../common/EditActionComponent'
import { EditableImageUploader, ImagePreview } from '../common/ImageUploader'
import { EditableColorPicker, ColorSwatch } from '../common/ColorPicker'
import { uploadAssetAPI } from '../../api/assets'
import { EditableTextField, EditableSwitch } from '../common/EditableComponents'

class TvDisplay extends PureComponent {
  onChange = onChangeEditHOF(this.props.onChange)

  onSave = () => {
    this.props.onSave((response) => this.props.disableEdit())
  }

  onCancel = () => {
    this.props.onCancel()
  }

  uploadBackgroundImage = (file, type, url) => {
    return new Promise((res, rej) => {
      uploadAssetAPI(file, 'photo/public').then((response) => {
        this.props.onChange('backgroundImage', response)
        res(response)
      })
    })
  }

  onColorChange = (key) => (color) => {
    this.props.onChange(key, color.hex)
  }

  render() {
    const { data, editMode, assignedShop = {} } = this.props

    return (
      <Grid container>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          {hasAccess() ? (
            <div className="pull-right margin-bottom-small">
              <EditActionComponent
                onSave={this.onSave}
                onCancel={this.onCancel}
                onEdit={this.props.enableEdit}
                editMode={editMode}
              />
            </div>
          ) : (
            <div className="pull-right margin-bottom-small"></div>
          )}
        </Grid>
        <Grid item xs={12} sm={12} md={12} lg={12}>
          <Paper className="paper-page">
            <ListItem>
              <Grid container>
                <Grid item xs={12} sm={12} md={12} lg={12} className="txt-bold">
                  <h2>{assignedShop.name || ''}</h2>
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} className="txt-bold">
                  Enabled
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} className="select-margin set-width">
                  <EditableSwitch
                    valueToRender={data.enabled ? 'Enabled' : 'Disabled'}
                    checked={data.enabled}
                    editMode={editMode}
                    onChange={this.onChange('enabled', true)}
                  />
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid item xs={12} sm={6} md={6} lg={6} className="txt-bold">
                  Background Color
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <EditableColorPicker
                    valueToRender={<ColorSwatch color={data.backgroundColor || '#1cc4e8'} />}
                    color={data.backgroundColor || '#1cc4e8'}
                    onColorChange={this.onColorChange('backgroundColor')}
                    editMode={editMode}
                  />
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid item xs={12} sm={6} md={6} lg={6} className="txt-bold">
                  Theme Color
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <EditableColorPicker
                    valueToRender={<ColorSwatch color={data.themeColor || '#1cc4e8'} />}
                    color={data.themeColor || '#1cc4e8'}
                    onColorChange={this.onColorChange('themeColor')}
                    editMode={editMode}
                  />
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid item xs={12} sm={6} md={6} lg={6} className="txt-bold">
                  Button Text Color
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <EditableColorPicker
                    valueToRender={<ColorSwatch color={data.buttonTextColor || '#1cc4e8'} />}
                    color={data.buttonTextColor || '#1cc4e8'}
                    onColorChange={this.onColorChange('buttonTextColor')}
                    editMode={editMode}
                  />
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid item xs={12} sm={6} md={6} lg={6} className="txt-bold">
                  Background Image
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6} className="select-margin set-width">
                  <EditableImageUploader
                    editMode={editMode}
                    valueToRender={
                      <ImagePreview
                        src={(data.backgroundImage && createGetUrl(data.backgroundImage.key)) || ''}
                      />
                    }
                    src={(data.backgroundImage && createGetUrl(data.backgroundImage.key)) || ''}
                    imageUploadAPI={this.uploadBackgroundImage}
                  />
                </Grid>
              </Grid>
            </ListItem>
            <ListItem>
              <Grid container>
                <Grid item xs={12} sm={6} md={6} lg={6} className="txt-bold">
                  Welcome Text
                </Grid>
                <Grid item xs={12} sm={6} md={6} lg={6}>
                  <EditableTextField
                    valueToRender={data.welcomeText}
                    editMode={editMode}
                    value={data.welcomeText}
                    onChange={this.onChange('welcomeText')}
                    type="text"
                    InputLabelProps={{
                      shrink: true,
                    }}
                  />
                </Grid>
              </Grid>
            </ListItem>
          </Paper>
        </Grid>
      </Grid>
    )
  }
}

export default TvDisplay



// WEBPACK FOOTER //
// ./src/components/Kiosk/index.js